import React from "react";
import CategoryList from "../components/Shared/Category/CategoryList";
import FeaturedList from "../components/Home/FeaturedList/FeaturedList";
import ImageCardList from "../components/Home/ImageCardList/ImageCardList";

const Home = () => {
  return (
    <>
      <CategoryList />
      <ImageCardList title="Top categories of the month" />
      <FeaturedList />
      <ImageCardList />
    </>
  );
};

export default Home;
